// ABOUTME: Success checkmark in circle icon component
// ABOUTME: Supports className, size, and color customization

interface IconProps {
  className?: string
  size?: number
  color?: string
}

export const SuccessCheckIcon = ({ className = "", size = 14, color = "#111928" }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M7 0.75C5.66498 0.75 4.35994 1.14588 3.2499 1.88758C2.13987 2.62928 1.27471 3.68348 0.763816 4.91689C0.252925 6.15029 0.119252 7.50749 0.379702 8.81686C0.640153 10.1262 1.28303 11.329 2.22703 12.273C3.17104 13.217 4.37377 13.8598 5.68314 14.1203C6.99251 14.3807 8.34971 14.2471 9.58312 13.7362C10.8165 13.2253 11.8707 12.3601 12.6124 11.2501C13.3541 10.1401 13.75 8.83502 13.75 7.5C13.748 5.71039 13.0362 3.99464 11.7708 2.7292C10.5054 1.46375 8.78961 0.751965 7 0.75ZM9.50223 6.62722L6.80223 9.32722C6.67565 9.45377 6.50399 9.52485 6.325 9.52485C6.14602 9.52485 5.97436 9.45377 5.84778 9.32722L4.49778 7.97722C4.37482 7.84992 4.30678 7.67941 4.30832 7.50243C4.30986 7.32545 4.38085 7.15615 4.506 7.031C4.63115 6.90585 4.80045 6.83486 4.97743 6.83332C5.15441 6.83178 5.32492 6.89982 5.45223 7.02277L6.325 7.89555L8.54778 5.67277C8.67508 5.54982 8.84559 5.48178 9.02257 5.48332C9.19956 5.48486 9.36885 5.55585 9.494 5.681C9.61915 5.80615 9.69014 5.97545 9.69168 6.15243C9.69322 6.32941 9.62518 6.49992 9.50223 6.62722Z"
      fill={color}
    />
  </svg>
)
